// TODO(benedictkhoo): remove after assets unification is done
import { Account as Asset } from '~/store/assets/types'
import { ActionTypes, Dispatch } from '~/store/types'
import { ACCOUNT_ACTIONS } from './const'
import { Account, AccountDetail } from './types'

export const resetAccountList = () => (dispatch: Dispatch<ActionTypes>) => {
  dispatch({
    type: ACCOUNT_ACTIONS.SET_ACCOUNT_LIST,
    accountList: [],
  })
}

export const resetAccountDetailList = () => (dispatch: Dispatch<ActionTypes>) => {
  dispatch({
    type: ACCOUNT_ACTIONS.SET_ACCOUNT_DETAIL_LIST,
    accountDetailList: [],
  })
}

export const setAccountList = (assets: Asset[]) => (dispatch: Dispatch<ActionTypes>) => {
  let accountList: Account[] = []

  if (assets.length > 0) {
    accountList = assets.map(asset => {
      return {
        accountId: asset.accountId,
        balance: asset.balance,
        currency: asset.currency,
        formattedBalance: asset.formattedBalance,
        fundPoolId: asset.fundPoolId,
        id: 2, // hard coded in AccountSerializer (app/namespaces/serializers/sg/account_serializer.rb)
        name: asset.name,
        type: asset.type,
        uniqueId: asset.uniqueId,
      }
    })
  }

  dispatch({
    type: ACCOUNT_ACTIONS.SET_ACCOUNT_LIST,
    accountList,
  })
}

export const setAccountDetailList = (assets: Asset[]) => (dispatch: Dispatch<ActionTypes>) => {
  let accountDetailList: AccountDetail[] = []

  if (assets.length > 0) {
    accountDetailList = assets.map(asset => {
      return {
        attributes: {
          asb: true,
          balance: asset.balance,
          currency: asset.currency,
          deletedAt: '',
          fundPoolId: asset.fundPoolId,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          limitations: asset.limitations as any, // FiatWithdrawLimitCalculationService returns a different schema (app/namespaces/services/fiat_withdraw_limit_calculation_service.rb)
          title: '',
          transactionLimitIncrementDate: {} as never, // InfoForSdkSerializer will always return {} (app/namespaces/serializers/sg/info_for_sdk_serializer.rb)
          type: asset.type,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          walletId: asset.walletId as any, // uses WalletIdType, which also supports undefined
          walletName: asset.walletName,
        },
        id: asset.uniqueId,
      }
    })
  }

  dispatch({
    type: ACCOUNT_ACTIONS.SET_ACCOUNT_DETAIL_LIST,
    accountDetailList,
  })
}
